import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { ConversationService } from 'src/app/conversation.service';
import { TableControlService } from 'src/app/table-control.service';
import { faFileDownload, faFilter, faPhone, faRotateLeft, faRefresh } from '@fortawesome/free-solid-svg-icons';
import { NgbModal, NgbTooltip, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem, NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { SmsCallFilterModalComponent } from 'src/app/shared/modals/sms-call-filter-modal/sms-call-filter-modal.component';
import { CallService } from 'src/app/call.service';
import { CallDialerDialogComponent } from '../call-dialer-dialog/call-dialer-dialog.component';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration' // ES 2015
import { TwilioService } from 'src/app/twilio.service';
import { CurrencyPipe, DatePipe, NgIf, NgFor } from '@angular/common';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-call-history',
    templateUrl: './call-history.component.html',
    styleUrls: ['./call-history.component.css'],
    providers: [DatePipe],
    standalone: true,
    imports: [NgIf, NgbTooltip, FaIconComponent, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem, NgFor, NgbPagination, DatePipe]
})
export class CallHistoryComponent implements OnInit, OnDestroy {
  //Screensize event Listener
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.resizeSubject.next((event.target as Window).innerWidth);
  }

  // Variable Subject
  private resizeSubject: Subject<number> = new Subject<number>();

  subs = new Subscription();
  calls: any[]
  totalCalls = 0;
  tableControls: TableControlService;
  twilioDevice: any;
  statusFilter: Array<any> = [
    {label:"Busy", value: 'busy'},
    {label:"Canceled", value: 'canceled'},
    {label:"Completed", value: 'completed'},
    {label:"Failed", value: 'failed'},
    {label:"In Progress", value: 'in-progress'},
    {label:"No Answer", value: 'no-answer'},
    {label:"Queued", value: 'Queued'},
    {label:"Ringing", value: 'Ringing'}
    ];
  filters: any;
  isMobileView: boolean = false;
  startDate: string = '';
  endDate: string = '';
  fromContact: string = null;
  toContact: string = null;
  selectedStatus: string = null;


  faFileDownload = faFileDownload
  faFilter = faFilter;
  faPhone = faPhone;
  faRotateLeft = faRotateLeft;
  faRefresh = faRefresh;

  // Get isMobile value in reactive way
  public get isMobile(): boolean {
    return this.isMobileView;
  }

  constructor(
    private conversationService: ConversationService,
    private modalService: NgbModal,
    private callService: CallService,
    private twilioService: TwilioService,
    private datePipe: DatePipe,
    private currencyPipe: CurrencyPipe,
    private loaderService: LoaderService
  ) {
    this.resizeSubject.pipe(
      debounceTime(100)
    ).subscribe(width => {
      if (width <= 768) {
        this.checkScreenSize(width);
      } else {
        this.isMobileView = false;
        this.tableControls.setLimit(20);
      }
    });
   }

  ngOnInit(): void {
    this.tableControls = new TableControlService('Calls', false, null, null, null, 20, 1);
    this.checkScreenSize();
    this.startDate = dayjs().startOf('week').format('YYYY-MM-DD');
    this.endDate = dayjs().endOf('week').format('YYYY-MM-DD');
    this.getHistory();
    this.subs.add(
      this.callService.twilioDevice
      .pipe()
      .subscribe((data) => {
        this.twilioDevice = data;
      })
    );
  }

  reset() {
    this.startDate = dayjs().startOf('week').format('YYYY-MM-DD');
    this.endDate = dayjs().endOf('week').format('YYYY-MM-DD');
    this.selectedStatus = null;
    this.fromContact = null;
    this.toContact = null;
    this.getHistory();
  }


  getHistory(page: number = 1) {
    this.loaderService.showSpinner();
    let rquestBody = {
      limit: this.tableControls.getLimit() || 20,
      page,
      startDate: this.startDate,
      endDate: this.endDate,
      from: this.fromContact,
      to: this.toContact,
      status: this.selectedStatus,
    }
    this.subs.add(
      this.conversationService.callHistory(rquestBody)
        .subscribe({
          next:(res) => {
            this.calls = res.calls;
            this.totalCalls = res.count;
          },
          error: () => {
            this.loaderService.hideSpinner();
          },
          complete: () => {
            this.loaderService.hideSpinner();
          }
        })
    )
  }

  getDate(date) {
    let year = date?.year ? date?.year : null;
    let month = date?.month ? this.formatDayAndMonth(date?.month) : null;
    let day = date?.day ? this.formatDayAndMonth(date?.day) : null;
    return {year, month, day};
  }

  download() {
    // TODO
  }

  async callAgain(calledNumber: string) {
    this.conversationService.getContactByNumber(calledNumber)
      .subscribe(res => {
        const modalRef = this.modalService.open(CallDialerDialogComponent, { windowClass: "callDialerDialog" });
        modalRef.componentInstance.passedContact = res;

        modalRef.componentInstance.call.subscribe((res) => {
          this.openInCallDialog(res);
        });
      })

  }

  async openInCallDialog(data: any) {
    const phoneNumber = data.number.replace(/\D/g, '')
    const formattedNumber = Number(phoneNumber)
    // TODO direct call
    const outGoingCall = await this.twilioDevice.connect({
      params: { To: `+1${formattedNumber}`, 'contactId': data.contact.id }
    });
    this.twilioService.outgoingConnection = outGoingCall
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }


  openFilterModal() {
    const modalRef = this.modalService.open(SmsCallFilterModalComponent);
    modalRef.componentInstance.title = "Filter Call History";
    modalRef.componentInstance.showStatus = true;
    modalRef.componentInstance.status = this.statusFilter;
    modalRef.componentInstance.filtersApplied.subscribe((filters: any) => {
      this.onFiltersApplied(filters);
    });

  }


  onFiltersApplied(filters: any) {
    const getStartDate = this.getDate( filters?.startDate);
    const getEndDate = this.getDate( filters?.endDate);
    this.startDate =  filters?.startDate ? `${getStartDate?.year}-${getStartDate?.month}-${getStartDate?.day}` : null;
    this.endDate =  filters?.endDate ? `${getEndDate?.year}-${getEndDate?.month}-${getEndDate?.day}` : null;
    this.selectedStatus = filters?.status?.value;
    this.fromContact = filters?.fromContact;
    this.toContact = filters?.toContact;
    this.getHistory()
  }

  formatSeconds(seconds) {
    dayjs.extend(duration)
    const formatted = dayjs.duration(seconds, 'seconds');
    return formatted.format('H[h] m[m] s[s]')
  }

  formatDayAndMonth(number: number) {
    return  number <= 9 ? `0${number}`: `${number}`;
  }

  export() {
    let rquestBody = {
      limit: 100000,
      page: 1,
      startDate: this.startDate,
      endDate: this.endDate,
      from: this.fromContact,
      to: this.toContact,
      status: this.selectedStatus,
    }
    this.subs.add(
      this.conversationService.callHistory(rquestBody)
        .subscribe(res => {
        const d = new Date();
        const date = `${d.getMonth() + 1}-${d.getDate()}-${d.getFullYear()}`
        const fileName = `Call_History_${date}`
        this.exportToCSV(fileName,res.calls);

        })
    )
  }

  exportToCSV(filename: string, data: any): void {
    const csvString = this.jsonToCSV(data);
    const blob = new Blob([csvString], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('download', filename);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  jsonToCSV(data: any): string {
    const headers = ['date_created', 'contactFrom', 'from', 'contactTo', 'to', 'status', 'direction', 'duration','recordingUrl'];
    const csvHeaders = ['Date', 'From Contact Name','From Contact Number', 'To Contact Name','To Contact Number', 'Status', 'Direction', 'Duration', 'Recordings']
    const csvRows = data.map(obj =>
      headers.map(header => this.formatValue(header, obj[header])).join(',')
    );
    return [csvHeaders, ...csvRows].join("\n");
  }


formatValue(header: string, value: any): string {
  if (value === null || value === undefined) {
    return '';
  }
  let formattedValue: string;

  switch (header) {
    case 'date_created':
      formattedValue = this.formatDate(value);
      break;
    case 'duration':
      formattedValue = this.formatSeconds(value);
      break;
    case 'price':
      formattedValue = this.formatPrice(value);
      break;
    default:
      formattedValue = String(value).trim();
  }

  return `"${formattedValue}"`;
}

  formatDate(dateCreated: string | Date): string | null {
    return this.datePipe.transform(dateCreated, 'short');
  }

  formatPrice(price: number): string | null {
    return this.currencyPipe.transform(price, 'USD', 'symbol', '1.3-4');
  }

   //Set isMobile value and set table limit base on screen size
   checkScreenSize(width?: number) {
    let screenWidth = width || window.innerWidth;
    this.isMobileView =  screenWidth <= 768;
    this.isMobileView ? this.tableControls.setLimit(5): this.tableControls.setLimit(20);
  }


}
